import { Row, Col, Breadcrumb } from "react-bootstrap";

const BreadCrumbs = () => {
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/abstractions">Abstraction</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default BreadCrumbs;
